module.exports = __webpack_public_path__ + "static/media/open.dedb6636.svg";